export default {
  account: {
    academy_capitalized: "ACADEMIA",
    change_photo: "Cambiar foto",
    currency: "Moneda",
    currency_description: "Moneda para las tarifas de los estudiantes y la nómina de los profesores.",
    email_capitalized: "E-MAIL",
    first_name_capitalized: "NOMBRE",
    language: "Idioma",
    language_settings: "Configuración de idioma",
    last_name_capitalized: "APELLIDO",
    personal_information: "Información personal",
    plan_usage: "Plan y uso",
    policy: "Política",
    policy_setting_before: "horas antes",
    policy_setting_cancel: "Cancelación",
    policy_setting_cancel_subtitle: "Establezca cuántas horas de anticipación se puede solicitar la cancelación de una clase.",
    policy_subtitle: "Establezca cuántas horas de anticipación se puede solicitar la reprogramación de una clase.",
    profile: "Perfil",
    reschedule: "Reprogramar",
    subscription: "Suscripción",
    subscription_info_contact: "{'Por favor, contacte a yan@getfunclass.com para gestionar o cancelar su suscripción. ¡Gracias!'}",
    subtitle: "Puede gestionar la configuración de su cuenta aquí.",
    title: "Configuración de cuenta"
  },
  auth: {
    agency_name: "Centro de matrícula",
    agree_to: "Acepto los",
    alreadyhasaccount: "¿Ya tienes una cuenta?",
    confirmPassword: "Confirmar contraseña",
    createaccount: "Crear cuenta",
    email: "E-mail",
    email_enter: "Introduce tu E-mail",
    email_send: "Enviar un e-mail",
    firstname: "Primer nombre",
    firstname_student: "Primer nombre del estudiante",
    forgotpassword: "¿Olvidaste tu contraseña?",
    hasaccount: "¿No tienes una cuenta?",
    lastname: "Apellido",
    login: "Iniciar sesión",
    loginbutton: "Iniciar sesión",
    logout: "Cerrar sesión",
    no_active_account: "No se encontró una cuenta activa con las credenciales",
    password: "Contraseña",
    passwordreset: "Restablecer tu contraseña",
    passwordresetbutton: "Restablecer contraseña",
    required: {
      agency_name: "Se requiere el nombre de la academía",
      email: "Se requiere email",
      email_exists: "Ya existe una cuenta con este email",
      first_name: "Se requiere el primer nombre",
      invalid_email: "El email no es válido",
      last_name: "Se requiere apellido",
      password: "Se requiere contraseña",
      password_length: "La contraseña debe tener al menos 8 caracteres",
      password_requirement: "La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número y un carácter especial ({'@'} $ ! % * ? & #)."
    },
    reset: "Restablecer",
    signup: "Registrarse",
    signup_subtitle: "Ingresa tus credenciales para crear una cuenta en Funclass.",
    terms: "Términos y condiciones"
  },
  button: {
    archive: "Archivar",
    copy: "Copiar",
    delete: "Eliminar",
    edit: "Editar",
    invite: "Invitar",
    save: "Guardar",
    submit: "Enviar",
    unarchive: "Desarchivar"
  },
  course: {
    chinese_students: "Esta clase tiene estudiantes en China",
    class_name: "Nombre de la clase",
    class_name_placeholder: "Ingresa el nombre de tu clase aquí",
    class_settings: {
      account_type: "Tipo de cuenta",
      account_type_warning_non_gamified: "Los estudiantes no tendrán una mascota y no recolectarán XP/HP.",
      account_type_warning_setup: "El tipo de gamificación solo se puede establecer una vez durante la creación de la clase.",
      enable_breakout_room: "Activar sala de grupos (desactiva unión automática de audio)",
      gamified: "Gamificado",
      non_gamified: "No gamificado",
      recording_exclude_webcam: "La grabación no incluye la cámara de los estudiantes",
      title: "Configuración del aula"
    },
    create: "Añadir clase",
    delete: "eliminar",
    delete_confirmation: "Confirmación de eliminación",
    delete_message: "¿Seguro que quieres eliminar esta clase?",
    delete_student: "¿Seguro que quieres eliminar a este estudiante de la clase?",
    duration: "Duración",
    duration_time_unit: "minutos",
    edit: "Editar clase",
    filters: {
      active: "Clases activas",
      all: "Todas las clases",
      archived: "Clases archivadas"
    },
    join: "Unirse a la clase",
    link_valid_for: "Este enlace es válido durante {n} día(s).",
    name_too_short: "El nombre del curso debe tener al menos 2 caracteres",
    no_content: {
      filtered: {
        subtitle: "Prueba a cambiar los filtros.",
        title: "No hay clases aquí"
      },
      general: {
        teacher_subtitle: "Haz clic en “Añadir clase” para empezar",
        teacher_subtitle_agency: "Aún no tienes cursos asignados. Espera a que tu academia te asigne uno.",
        title: "Aún no se ha creado ninguna clase"
      }
    },
    notify: {
      archive_course_error: "Error al archivar el curso",
      archive_course_success: "¡La clase {courseName} se ha archivado correctamente!",
      copy_link_error: "Error al copiar el enlace",
      copy_link_success: "¡Copiado!",
      delete_course_error: "Error al eliminar el curso",
      edit_course_error: "Error",
      required_fields: "Por favor, completa los campos obligatorios",
      start_meeting_error: "Error al iniciar la reunión. Inténtalo de nuevo.",
      unarchive_course_error: "Error al desarchivar el curso",
      unarchive_course_success: "¡La clase {courseName} se ha desarchivado correctamente!"
    },
    please_resubscribe: "Por favor, vuelve a suscribirte a Funclass para continuar.",
    progress: "Progreso",
    resubscribe: "Volver a suscribirse",
    share: "Compartir clase",
    shareText: "Comparte el enlace para invitar a tus estudiantes a unirse a la clase",
    start: "Iniciar clase",
    subscription_expired: "Suscripción expirada",
    title: "Panel de la clase",
    view: "Ver clase"
  },
  datetime: {
    days: {
      friday: "Viernes",
      initials: {
        friday: "V",
        monday: "L",
        saturday: "M",
        sunday: "X",
        thursday: "J",
        tuesday: "V",
        wednesday: "S"
      },
      monday: "Lunes",
      saturday: "Sábado",
      short: {
        friday: "Vie",
        monday: "Lun",
        saturday: "Sáb",
        sunday: "Dom",
        thursday: "Jue",
        tuesday: "Mar",
        wednesday: "Mié"
      },
      sunday: "Domingo",
      thursday: "Jueves",
      tuesday: "Martes",
      wednesday: "Miércoles"
    },
    time_format: "a las {time}",
    today: "Hoy",
    tomorrow: "Mañana",
    yesterday: "Ayer"
  },
  homework: {
    assign: {
      assignment_info: {
        attach_files: "Adjuntar archivos",
        attachments: "Archivos adjuntos",
        choose_class: "Elige una clase para asignar",
        class: "Clase",
        description: "Descripción de la tarea",
        due_date: "Fecha de entrega (tu hora local)",
        due_date_past: "La fecha de entrega debe estar en el futuro",
        submission_required: "Entrega requerida",
        title: "Título",
        title_required: "El título es obligatorio"
      },
      confirm_leave: "¿Seguro que quieres salir de esta página? Tus cambios no se guardarán.",
      create: "Asignar",
      remove_attachment: "Eliminar",
      title: "Asignar tarea",
      upload_attachments: "Sube tu(s) archivo(s) adjunto(s)"
    },
    dashboard: {
      archived: "Archivado",
      create: "Asignar tarea",
      delete_button: "Eliminar {assignment}",
      delete_confirmation: "Confirmación de eliminación",
      delete_message: "¿Seguro que quieres eliminar esta tarea?",
      due: "Fecha de entrega",
      filters: {
        all_classes: "Todas las clases",
        all_graded: "Todas calificadas",
        any_status: "Cualquier estado",
        archived: "Archivadas",
        assigned: "Asignadas",
        no_submission_needed: "No requiere entrega",
        to_be_graded: "Por calificar"
      },
      graded_on: "Calificada el",
      header: {
        class: "Clase",
        due: "Entrega",
        status: "Estado",
        title: "Título"
      },
      na: "N/D",
      no_content: {
        completed: {
          subtitle: "Tus tareas completadas pendientes de calificación aparecerán aquí.",
          title: "No hay tareas completadas"
        },
        filtered: {
          subtitle: "Prueba a cambiar los filtros para encontrar la tarea que buscas.",
          title: "Ninguna tarea coincide con tus filtros"
        },
        general: {
          subtitle: "Haz clic en el botón “Asignar tarea” para empezar",
          title: "Aún no se ha creado ninguna tarea"
        },
        graded: {
          subtitle: "Tus tareas calificadas aparecerán aquí.",
          title: "No hay tareas calificadas"
        },
        pending: {
          subtitle: "Vuelve más tarde para ver nuevas tareas.",
          title: "No hay tareas pendientes"
        }
      },
      no_due_date: "Sin fecha de entrega",
      notify: {
        archive_assignment_error: "Error al archivar la tarea. Inténtalo de nuevo más tarde.",
        archive_assignment_success: "¡Tarea archivada con éxito!",
        delete_assignment_error: "Error al eliminar la tarea. Inténtalo de nuevo más tarde.",
        delete_assignment_success: "¡Tarea eliminada con éxito!",
        unarchive_assignment_error: "Error al desarchivar la tarea. Inténtalo de nuevo más tarde.",
        unarchive_assignment_success: "¡Tarea desarchivada con éxito!"
      },
      num_submitted: "{submitted} / {total} entregadas",
      submission_not_required: "No requiere entrega",
      submit: "Enviar",
      submitted_on: "Enviado el",
      tabs: {
        completed: "Completado",
        graded: "Calificado",
        pending: "Pendiente"
      },
      title: "Panel de tareas",
      view_submission: "Ver"
    },
    details: {
      attach_files: "Adjuntar archivos",
      attachments: "Archivos adjuntos",
      delete_button: "Eliminar {assignment}",
      delete_confirmation: "Confirmación de eliminación",
      delete_message: "¿Seguro que quieres eliminar esta tarea?",
      description: "Descripción",
      download_attachment: "Descargar",
      due: "Entrega",
      edit_homework: "Editar tarea",
      edit_submission: "Editar entrega",
      graded_on: "Calificada el",
      homework_details: "Detalles de la tarea",
      homework_submission: "Entrega de tarea",
      not_submitted: "No entregada",
      post_submission_success: "¡Entrega enviada con éxito!",
      remove_attachment: "Eliminar",
      reward: "Recompensa:",
      student_submissions: "Entregas de estudiantes",
      submission_not_required: "No requiere entrega",
      submit_homework: "Enviar",
      submitted_on: "Enviado el",
      teacher_feedback: "Comentarios del profesor",
      title: "Tarea",
      upload_attachments: "Sube tu(s) archivo(s) adjunto(s)",
      view_submission: "Ver",
      your_submission: "Tu entrega"
    },
    edit: {
      assignment_info: {
        attach_files: "Adjuntar archivos",
        attachments: "Archivos adjuntos",
        choose_class: "Elige una clase para asignar",
        class: "Clase",
        description: "Descripción de la tarea",
        due_date: "Fecha de entrega (tu hora local)",
        due_date_past: "La fecha de entrega debe estar en el futuro",
        submission_required: "Entrega requerida",
        title: "Título",
        title_required: "El título es obligatorio"
      },
      confirm_leave: "¿Seguro que quieres salir de esta página? Tus cambios no se guardarán.",
      keep_attachment: "Conservar",
      remove_attachment: "Eliminar",
      save_changes: "Guardar cambios",
      title: "Editar tarea",
      upload_attachments: "Sube tu(s) archivo(s) adjunto(s)"
    },
    edit_submission: {
      attach_files: "Adjuntar archivos",
      attachments: "Archivos adjuntos",
      description: "Descripción",
      download_attachment: "Descargar",
      due: "Entrega",
      edit_submission_success: "¡Entrega editada con éxito!",
      homework_details: "Detalles de la tarea",
      keep_attachment: "Conservar",
      last_submitted_on: "La última entrega fue el",
      remove_attachment: "Eliminar",
      resubmit_homework: "Volver a enviar",
      title: "Editar entrega",
      upload_attachments: "Sube tu(s) archivo(s) adjunto(s)",
      your_submission: "Tu entrega"
    },
    submission_details: {
      attach_files: "Adjuntar archivos",
      attachments: "Archivos adjuntos",
      description: "Entrega de tarea",
      download_attachment: "Descargar",
      graded_on: "Calificada el",
      remove_attachment: "Eliminar",
      reward: "Recompensa:",
      reward_xp: "Recompensa XP",
      reward_xp_placeholder: "Introduce la cantidad de XP aquí",
      rewarding: "Recompensando",
      save_reward: "Guardar",
      save_reward_success: "¡Cantidad de recompensa guardada con éxito!",
      send_feedback: "Enviar",
      send_feedback_success: "¡Comentarios enviados con éxito!",
      submitted_on: "Enviado el",
      teacher_feedback: "Comentarios del profesor",
      title: "Tarea",
      your_feedback: "Tus comentarios"
    }
  },
  inclass: {
    endLesson: "¿Quieres terminar la clase?"
  },
  inclassQuiz: {
    dragMe: "Arrástrame",
    folderTitle: "Seleccionar una carpeta",
    modeTitle: "Seleccionar un modo",
    noQuizYet1: "Aún no hay ningún cuestionario aquí.",
    noQuizYet2: "Por favor, crea uno primero fuera de la clase.",
    quizRuleDescription1: "• Por cada pregunta que los estudiantes acierten, el monstruo pierde una vida",
    quizRuleDescription2: "• Por cada pregunta que los estudiantes fallen, pierden una vida",
    quizRuleDescription3: "•⁠ Al final del cuestionario, los estudiantes deben tener más vidas que el monstruo para ganar la batalla",
    quizRuleDescriptionStudent1: "• Por cada pregunta que aciertes, el monstruo pierde una vida",
    quizRuleDescriptionStudent2: "• Por cada pregunta que falles, pierdes una vida",
    quizRuleDescriptionStudent3: "•⁠ Al final del cuestionario, debes tener más vidas que el monstruo para ganar la batalla",
    studentsJoinedCount: "estudiantes se han unido",
    teacherPreStartQuiz: "Estás a punto de comenzar el cuestionario...",
    title: "Seleccionar un cuestionario"
  },
  lesson_status: {
    cancelled: "Cancelado",
    completed: "Completado",
    completed_absence: "Completado (Ausencia)",
    no_show: "No Asistió",
    ongoing: "En Curso",
    rescheduled: "Reprogramado",
    scheduled: "Programado",
    started: "Iniciado"
  },
  meeting: {
    attention_tracker_disable: "Desactivar el rastreador de atención",
    attention_tracker_enable: "Activar el rastreador de atención",
    button_join_quiz: "Unirse al cuestionario activo"
  },
  misc: {
    handbook: "Manual"
  },
  my_calendar: {
    abort: "Cancelar",
    accept_request: "Aceptar Solicitud",
    all_members: "Todos los miembros",
    attendees: "Asistentes",
    cancel: "Cancelar",
    cancel_lesson: "Cancelar clase",
    cancel_lesson_title: "Cancelar Clase",
    cancellation_constraint: "Todas las cancelaciones deben realizarse al menos {hours} horas antes",
    confirm: "Confirmar",
    confirm_approve_reschedule: "¿Estás seguro de que deseas aprobar esta solicitud de reprogramación?",
    course: "Curso",
    date: "Fecha",
    date_time: "Fecha y Hora",
    day: "Día",
    from: "de",
    from_admin: "Desde Admin",
    join: "Unirse",
    month: "Mes",
    next: "Siguiente",
    notes: "Notas",
    notify: {
      approve_reschedule_request_error: "No se pudo aprobar la solicitud de reprogramación. Por favor, inténtalo de nuevo.",
      approve_reschedule_request_success: "Solicitud de reprogramación aprobada con éxito.",
      request_cancel_error: "No se pudo enviar la solicitud de cancelación de la lección. Por favor, inténtalo de nuevo.",
      request_cancel_success: "Solicitud de cancelación de la lección enviada con éxito.",
      request_reschedule_error: "No se pudo solicitar la reprogramación de la lección. Por favor, inténtalo de nuevo.",
      request_reschedule_success: "Reprogramación de la lección solicitada con éxito."
    },
    previous: "Anterior",
    reschedule: "Reprogramar",
    reschedule_constraint: "La solicitud de reprogramación debe realizarse al menos {hours} horas antes",
    reschedule_lesson_title: "Reprogramar Clase",
    reschedule_note: "Nota de Reprogramación",
    reschedule_requests: "Solicitudes de Reprogramación",
    save: "Guardar",
    send_request: "Enviar solicitud",
    students: "Estudiantes",
    subtitle: "Aquí puedes ver y gestionar todas tus clases y disponibilidad.",
    suggest_alternative_title: "Sugerir Alternativa",
    teachers: "Profesores",
    title: "Mi Calendario",
    to: "a",
    today: "Hoy",
    view_lesson: "Ver Clase",
    week: "Semana",
    your_requests: "Tus solicitudes"
  },
  my_items: {
    change_pet_button: "Cambiar mascota",
    confirm_button: "Confirmar",
    feed_button: "Alimentar",
    go_to_shop_button: "Ir a la tienda",
    no_content: {
      accessories: {
        subtitle: "Aún no has comprado nada.",
        title: "No hay accesorios disponibles"
      },
      food: {
        subtitle: "Aún no has comprado nada.",
        title: "No hay comida disponible"
      },
      pets: {
        subtitle: "Ve a la tienda para comprar mascotas.",
        title: "No hay mascotas disponibles"
      }
    },
    pet_reactions: {
      accessory: [
        "¡Esto es perfecto para mí!",
        "¡Me veo increíble con esto!",
        "¡Creo que encontré mi nuevo estilo!",
        "¡Esto me queda perfecto!",
        "¡Este accesorio me queda genial!",
        "¡No puedo creer lo bien que me queda esto!",
        "¡Definitivamente este estilo es mío!",
        "¡Este es totalmente mi estilo!",
        "¡Mírame, soy fabuloso!",
        "¡Me siento tan a la moda con esto!",
        "¡Oh wow, me veo increíble!",
        "¡Esto fue hecho para mí!",
        "¡Ahora me siento súper elegante!",
        "¡Esto sí es moda!",
        "¡Me veo genial!",
        "¡Demasiado tierno para soportar!",
        "¡Creo que este es mi nuevo favorito!",
        "¡Me siento como una superestrella!",
        "¡Nací para usar esto!",
        "¡Vestirme es muy divertido!"
      ],
      after_eating: [
        "Mmm, ¡ese {food_name} estaba delicioso! 😋",
        "¡Me encanta el {food_name}! ❤️",
        "¡Gracias por el {food_name}! 😊",
        "{food_name}! ¡Delicioso! 😋"
      ],
      full: [
        "¡Estoy llenísimo! 😋",
        "¡Ya estoy lleno! 😌",
        "¡He comido suficiente, gracias! 🙏"
      ],
      hungry: [
        "¡Tengo mucha hambre! 😢",
        "¿Me das algo de comer, por favor? 🍽️",
        "¡Mi estómago está rugiendo! 🥺",
        "¡Dame de comer, por favor! 🙏"
      ]
    },
    subtitle: "¡Estos son mis objetos!",
    tabs: {
      accessories: "Accesorios",
      food: "Comida",
      pets: "Mascotas"
    },
    take_off_button: "Quitar",
    title: "Mis objetos"
  },
  notifications: {
    empty: "Sin notificaciones",
    messages: {
      ASSIGNMENT_CREATED: "{name} ha creado la tarea {description}",
      ASSIGNMENT_GRADED: "{name} ha calificado la tarea {description}",
      ASSIGNMENT_SUBMITTED: "{name} ha entregado una tarea para {description}",
      ENROLLMENT_STUDENT: "{name} se ha inscrito en {description}",
      ENROLLMENT_STUDENT_AGENCY: "{name} se ha registrado en {description}",
      ENROLLMENT_TEACHER_AGENCY: "{name} se ha inscrito en tu agencia",
      LESSON_CANCELLED: "{name} ha cancelado una clase para {description}",
      LESSON_CANCEL_REQUESTED: "{name} ha solicitado cancelar una clase para {description}",
      LESSON_RESCHEDULED: "{name} ha reprogramado una clase para {description}",
      LESSON_RESCHEDULE_REQUESTED: "{name} ha solicitado reprogramar una clase para {description}",
      LESSON_REVIEWED: "{name} ha valorado tu {description}",
      STUDENT_REVIEWED: "{name} te ha dado comentarios para la clase {description}"
    },
    title: "Notificaciones"
  },
  onboarding_zoom: {
    student: {
      welcome_title: 'Bienvenido a Funclass ',
      welcome_subtitle: "¡Prepara tu clase en solo 2 pasos rápidos!",
      title_step_1: "Conecta Zoom para empezar a aprender",
      description_step_1_1: "Funclass utiliza Zoom para las clases. ¡Únete directamente desde Funclass, sin necesidad de enlaces!",
      description_step_1_2: "¡Gana recompensas con tus lecciones de Zoom mientras aprendes y haces crecer tu avatar en el camino!",
      connect_button: "Conectar Zoom",
      skip_button: "Omitir por ahora",
      watch_tutorial: "Ver video tutorial",
      tutorial_subtitle: "Aprende a usar Funclass en solo 1 minuto",
      finish_onboarding_button: "Comenzar a aprender",
      handbook_button: "Leer el manual"
    },
    teacher: {
    },
  },
  onboarding: {
    course: {
      browser_notice: [
        {
          acknowledgement_text: "He leído y comprendido.",
          body: [
            "",
            "Para un rendimiento y compatibilidad óptimos, utiliza uno de los navegadores compatibles a continuación 🚀",
            "🔹 Ordenador de sobremesa/portátil: Chrome, Firefox o Edge (última versión)",
            "🔹 Móvil (iOS 12.2+): Safari",
            "🔹 Móvil (Android 10.0+): Chrome"
          ],
          header: [
            "⚠️ Por favor lee: Navegadores compatibles"
          ]
        }
      ],
      egg_unhatched: "Tu mascota aún no ha salido del cascarón. Gana XPs en tu clase para subir al __Nivel {level}__ y hacer que tu huevo se abra.",
      teacher: [
        {
          body: [
            "En Funclass, los profesores pueden recompensar los esfuerzos y el progreso de los estudiantes con XPs (puntos de experiencia), ¡como en un juego!"
          ],
          button_text: "Siguiente",
          header: [],
          title: "¡Bienvenido a Funclass 🎉!"
        },
        {
          body: [
            "mostrar su proceso de aprendizaje",
            "subir de nivel a sus mascotas mágicas",
            "¡descubrir más sorpresas!"
          ],
          button_text: "Siguiente",
          header: [
            "No abuses de los XPs a menos que los estudiantes demuestren esfuerzo y progreso reales.",
            "Con los XPs, los estudiantes pueden..."
          ]
        },
        {
          body: [
            "Participación activa en clase",
            "Cuestionarios en clase",
            "Entrega de tareas",
            "Buena preparación para la clase",
            "y otros comportamientos positivos de aprendizaje..."
          ],
          button_text: "Siguiente",
          header: [],
          title: "Puedes recompensar a los estudiantes por..."
        },
        "",
        {
          body: [
            "Lee el Manual de Funclass para obtener consejos y buenas prácticas."
          ],
          header: []
        }
      ]
    },
    navigation: {
      finish: "Finalizar",
      next: "Siguiente",
      skip_now: "Saltar por ahora"
    }
  },
  profile: {
    avatar_actions: {
      my_items: "Mis elementos",
      pet_guide: "Guía de mascotas",
      shop: "Tienda"
    },
    avatar_messages: {
      first_xp: "¡Guau! Has ganado {lastXP} XPs en tu última clase. Te faltan {xpToNextLevel} XPs para que yo nazca. Me pregunto cómo me veré 🐣",
      hungry: "Tengo hambre 🥺. Gana comida en clase para darme de comer.",
      level_up: "¡Guau! Has ganado {lastXP} XPs en tu última clase. Te faltan {xpToNextLevel} XPs para alcanzar tu próximo nivel. ¡Sigue así!",
      pet_gone_generic: "Desafortunadamente, tu mascota se ha ido... 💔",
      pet_gone_named: "Desafortunadamente, {petName} se ha ido... 💔",
      pet_revive_hint_generic: "Reúne al menos 100 HPs para revivir a tu mascota.",
      pet_revive_hint_named: "Reúne al menos 100 HPs para revivir a {petName}.",
      pet_revived: "¡Gracias por esforzarte en traerme de vuelta! ¡Te echaba de menos! Ahora puedes darme de comer 🙂",
      welcome_back: "Hola {name}, ¡bienvenido de nuevo!👋 Estoy listo para aprender algo nuevo contigo hoy 📚✨",
      welcome_new: "Hola {name} 👋, ¡encantado de conocerte! Soy tu compañero de aprendizaje {petName}. Gana XPs en clase para que yo salga del cascarón 🐣"
    },
    coin_modal: {
      earned_coins: "¡Guau! Has ganado {rewardAmount} FunCoins",
      shop_button: "Ir a la tienda"
    },
    feedback_modal: {
      description: "Por favor, valora tu experiencia de clase a continuación",
      label: "¿Por qué das esta valoración?",
      lesson_not_ended: "¿La clase no ha terminado?",
      no_rating: "Sin valoración",
      rating_format: "{rating}/5 estrellas",
      rules: {
        max: "Los comentarios deben tener menos de 300 caracteres",
        min: "Los comentarios deben tener más de 10 caracteres",
        required: "Se requieren comentarios"
      },
      submit_button: "Enviar comentarios",
      title: "Comentarios de la clase"
    },
    level_up_modal: {
      submit_button: "Enviar"
    },
    pet_letter: {
      letter_title_generic: "Carta de tu mascota",
      letter_title_named: "Carta de {petName}",
      open_button: "Abrir",
      paragraph_1: "Fue muy bonito conocerte y ser tu compañero de aprendizaje. Me lo pasé genial aprendiendo contigo. Sin embargo, últimamente me he sentido algo ignorado 💔",
      paragraph_2: "Así que decidí irme un tiempo a buscar un entorno más cariñoso. Reúne 200 monedas para comprar una poción en la tienda y encontrarme de nuevo.",
      paragraph_3: "¡Espero volver a verte pronto!",
      received_title_generic: "Has recibido una carta de tu mascota",
      received_title_named: "Has recibido una carta de {petName}",
      signature: "Con cariño,\n{petName}"
    },
    revive_pet_modal: {
      revive_button: "Revivir",
      revive_message_generic: "Has reunido 100 HPs 🎉\nAhora puedes revivir a tu mascota.",
      revive_message_named: "Has reunido 100 HPs 🎉\nAhora puedes revivir a {petName}.",
      title: "Recompensa"
    },
    title: "Mi hogar",
    your_classes: "Tus clases"
  },
  quiz: {
    create: "Crear cuestionario",
    create_description: "Descripción del cuestionario",
    create_name: "Nombre del cuestionario",
    delete: "eliminar",
    delete_confirmation: "Confirmación de eliminación",
    delete_message: "¿Seguro que quieres eliminar este cuestionario?",
    edit: {
      add_alt_answer: "Añadir respuesta alternativa",
      add_answer: "Añadir respuesta",
      add_question: "Añadir pregunta",
      delete_message: "¿Seguro que quieres eliminar esta pregunta?",
      delete_question: "Eliminar pregunta",
      save_question: "Guardar preguntas",
      title: "Editar cuestionario"
    },
    edit_questions: "Editar preguntas",
    folder: {
      create: "Crear carpeta",
      create_name: "Nombre de la carpeta",
      delete: "Eliminar carpeta",
      delete_confirmation: "Confirmación de eliminación",
      delete_message: "¿Estás seguro de que deseas eliminar esta carpeta? Esto eliminará todos los cuestionarios dentro de la carpeta.",
      edit: "Editar Carpeta",
      name_limit: "Los caracteres no pueden exceder los 50",
      name_not_empty: "El nombre de la carpeta no puede estar vacío",
      save: "Guardar Carpeta",
      title: "Panel de Cuestionarios"
    },
    name_limit: "Los caracteres no pueden exceder los 50",
    name_not_empty: "El nombre del cuestionario no puede estar vacío",
    save: "Guardar Cuestionario",
    title: "Panel de Cuestionarios"
  },
  recording: {
    delete_confirmation: "¿Estás seguro de que deseas eliminar esta grabación?"
  },
  scheduling: {
    edit: {
      error: "Ocurrió un error al actualizar el evento",
      options: {
        current: "Esta lección",
        future: "Esta y las futuras lecciones",
        title_delete: "Selecciona eventos para eliminar",
        title_edit: "Selecciona eventos para aplicar cambios"
      },
      title: "Editar Lección Programada"
    },
    end_date: "Fecha de finalización",
    lesson_time: "Hora de la lección",
    lesson_time_info: "Selecciona tu hora local. Ajustamos automáticamente la hora a la zona horaria de los estudiantes.",
    recurrence: {
      biweekly: "Cada 2 semanas",
      custom: "Personalizado",
      daily: "Diariamente",
      label: "Recurrencia",
      none: "Ninguna",
      occurs_on: "Ocurre el",
      repeat_every: "Repetir cada",
      time_unit_day: "día | días",
      time_unit_week: "semana | semanas",
      weekly: "Semanal"
    },
    reminder: {
      hours_before: "{n} hora antes | {n} horas antes",
      label: "Recordatorio para los estudiantes"
    },
    start_date: "Fecha de inicio"
  },
  shop: {
    buy_now_button: "Comprar ahora",
    buy_pet_button: "Comprar mascota",
    cancel_button: "Cancelar",
    confirm_button: "Confirmar",
    level_constraint: "Alcanza el nivel {level} para desbloquear este objeto",
    no_content: {
      accessories: {
        subtitle: "Vuelve más tarde para ver más objetos.",
        title: "No hay accesorios disponibles"
      },
      food: {
        subtitle: "Vuelve más tarde para ver más objetos.",
        title: "No hay comida disponible"
      },
      pets: {
        subtitle: "Vuelve más tarde para ver más mascotas.",
        title: "No hay mascotas disponibles"
      },
      wallpapers: {
        subtitle: "Vuelve más tarde para ver más fondos de pantalla.",
        title: "No hay fondos de pantalla disponibles"
      }
    },
    notify: {
      pet_name_required: "Por favor, ingresa un nombre para la mascota"
    },
    pet_name: "Nombre de la mascota",
    pet_name_prompt: "¡Dale un nombre a tu mascota!",
    subtitle: "¡Aquí puedes comprar objetos para tu mascota!",
    title: "Tienda"
  },
  sidebar: {
    actions: {
      account_settings: "Configuración de la cuenta",
      logout: "Cerrar sesión"
    },
    activities: {
      homework: "Tarea",
      quiz: "Cuestionario",
      short_title: "Actuar",
      title: "Actividades"
    },
    agency_name_placeholder: "Tu institución",
    courses: {
      calendar: "Calendario",
      courses: "Cursos",
      history: "Historial",
      short_title: "Crs",
      title: "Cursos"
    },
    general: {
      home: "Inicio",
      short_title: "Gen",
      students: "Estudiantes",
      teachers: "Profesores",
      title: "General"
    }
  },
  understandingCheck: {
    start: "Estás a punto de lanzar la comprobación de comprensión",
    student: "¿Cómo te sientes ahora mismo?",
    studentButtonNo1: "Hmm🤔️",
    studentButtonNo2: "Un poco confundido.",
    studentButtonYes1: "¡Bien! 😄",
    studentButtonYes2: "Lo entendí.",
    teacher: "Cómo se sienten los estudiantes ahora mismo"
  },
  upload: {
    agency_logo_upload: "Sube el logo de tu institución",
    drag_and_drop: "o arrastra y suelta",
    photo_upload: "Sube tu imagen",
    pick_file: "Seleccionar un archivo",
    square_image: "Se recomienda una imagen cuadrada.",
    upload: "Subir",
    upload_file: "Subir archivo",
    upload_file_type: "Solo se aceptan formatos {formats}."
  },
  viewClass: {
    absence: "Ausencia",
    addMore: "Agregar más estudiantes",
    addStudent: "Invitar a un estudiante",
    addStudents: "Agregar estudiantes",
    attendance: "Asistencia",
    date: "Fecha",
    download_recording: "Descargar grabación",
    email: "Correo electrónico",
    enterEmail: "Ingresa el correo electrónico del estudiante aquí",
    feedback_button: "Retroalimentación",
    invite: "Invitar",
    lesson: "Lección",
    notEmpty: "El campo no puede estar vacío",
    notValid: "El correo electrónico no es válido",
    recording_button: "Grabación",
    student_name: "Nombre del estudiante",
    tabs: {
      course_material: "Diapositivas de clase",
      lesson_history: "Historial de lecciones",
      student_list: "Lista de estudiantes"
    },
    xps_earned: "XPs obtenidos"
  }
};
